<template>
  <div class="account-wrapper">
    <app-header></app-header> <hr>

    <div class="container">

       <div class="row mb-5">
        
         <div class="col-xl-2 col-lg-2 col-md-1 col-sm-12"></div>
         <div class="col-xl-8 col-lg-8 col-md-10 col-sm-12">
              
          <div class="card card-success">
             <div class="card-header">
                <h3 class="text-center">Manage <span class="text-primary">Your</span> Account</h3>
                <p class="text-center">
                 Here you can make changes to your profile, update info etc..
                </p>
             </div>

           <form>
             
             <div class="card-body">

                  <div class="row mb-4">
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 text-center">
                         <img :src="image" v-if="image !== null" alt="image" class="img img-fluid" style="width:170px; height:200px"> 
                         <br>
                         <a href="#" v-if="image !== null" class="text-center" @click="deleteCurrentPhoto()">
                          delete current photo
                        </a>
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 text-center">
                        <picture-input 
                          ref="pictureInput" 
                          @change="onChange" 
                          width="600" 
                          height="600" 
                          margin="16" 
                          accept="image/jpeg,image/png" 
                          size="10" 
                          :imgUpload=imgUpload
                          :imgSource=image
                          buttonClass="btn">
                        </picture-input>
                      </div>
                  </div>

                    <div class="form-group">
                        <label for="fname">First Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="fname" v-model="first_name" required 
                                placeholder="Enter your name">
                    </div>

                    <div class="form-group">
                        <label for="lname">Last Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="lname" v-model="last_name" required 
                                  placeholder="Enter your surname">
                    </div>

                    <div class="form-group">
                        <label for="email">Email Address <span class="text-danger">*</span></label>
                        <input type="email" class="form-control" id="email" v-model="email" required 
                                placeholder="Enter your email">
                    </div>

                    <div class="form-group">
                        <label for="contact">Phone Number <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="contact" v-model="phone" required 
                                placeholder="Enter your phone number">
                    </div>

                    <div class="form-group">
                      <label>Select Gate Type</label> <br>
                      <select class="form-select" v-model="gateID" @change="getAllStreet()" required>
                        <option value="">Select Gate Type</option>
                        <option v-for="gate in allGateTypes" :value="gate.id" :key="gate.id">
                          {{ gate.name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group" v-if="allStreets.length > 0">
                      <label>Select Street Name <span class="text-danger">*</span></label> <br>
                      <select class="form-select" v-model="street_name" @change="setUserName()" required>
                        <option value="">Select Street Name</option>
                        <option v-for="street in allStreets" :value="street.name" :key="street.id">
                          {{ street.name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group" v-else>
                        <label for="stname">Add Street Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="stname" v-model="street_name" required 
                                placeholder="Enter your street name">
                    </div>

                    <div class="form-group">
                        <label for="uname">Username <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="uname" v-model="username" required 
                                placeholder="Enter your username" disabled>
                    </div>

                    <!-- <div class="form-group">
                        <label for="hse">Add House Number <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="hse" v-model="house_number" 
                                placeholder="Enter your house number">
                    </div> -->
   
              </div>

              <div class="card-footer">
                  <button type="submit" @click.prevent="updateProfileUser()" class="btn btn-outline-primary btn-block">
                    Update Account
                  </button>
              </div>

            </form>

          </div>

         </div>
         <div class="col-xl-2 col-lg-2 col-md-1 col-sm-12"></div>

       </div>
         
    </div>

    <app-footer></app-footer>
  </div>
</template>

<script>
import PictureInput from 'vue-picture-input'
import Header from '@/components/layout/NewHeader'
import Footer from '@/components/layout/NewFooter'
import UserServices from "../../services/UserServices";
export default {
  data() {
    return {
      id: 0, 
      username: '', 
      first_name: '', 
      last_name: '', 
      street_name: '', 
      house_number: '', 
      email: '', 
      phone: '',
      image: '',
      imgUpload: false,
      allGateTypes:[],
      allStreets:[],
      gateID:'',
    }
  },
  components: {
    'picture-input': PictureInput,
    'app-header': Header,
    'app-footer': Footer
  },
  mounter() {
    console.log(this.valueInp)
  },
  created() {
    this.getUserProfile().then((response)=>{ 
      this.id = response.data.data.id
      this.username = response.data.data.name
      this.email = response.data.data.email
      this.phone = response.data.data.phone
      this.first_name = response.data.data.first_name
      this.last_name = response.data.data.last_name
      this.street_name = response.data.data.street_name
      this.house_number = response.data.data.house_number
      this.image = response.data.data.profile_pic;
      if(this.image!==null) {
        this.imgUpload = true;
      }
    });
    this.getAllGateType();
  },
  methods: {

    async getUserProfile(){
      try{
        const res = await UserServices.userProfile();
        return res;
      }
      catch (e) {
        return e;
      }
    },

    async updateProfile(){
      try {
        this.house_number = '123';
        const resp = await UserServices.userProfileUpdate(this.username, this.first_name, this.last_name, this.street_name, this.house_number, this.email, this.image, this.phone);
        console.log(resp)
        return resp;
      }
      catch (e) {
        return e;
      }
    },

    async deletePhoto(){
      try {
        const resp = await UserServices.deletePhoto();
        return resp;
      }
      catch (e) {
        return e;
      }
    },

    async gatetype(){
      try {
         const response = await UserServices.allGateType();
         return response;
      } catch (error) {
        console.log('error', error);
        return error;
      }
    },

    async getstreet(id){
      try {
         const response = await UserServices.getGateStreet(id);
         return response;
      } catch (error) {
        console.log('error', error);
        return error;
      }
    },

    setUserName(){
        this.username = this.street_name.replace(/-|\s+/g,'');
        console.log(this.name);
    },

    getAllGateType(){
       this.gatetype().then((res) => {
          this.allGateTypes = res.data.data;
       });
    },

    getAllStreet(){
      this.allStreets = [];
        this.getstreet(this.gateID).then((res) => {
          this.allStreets = res.data.data;
       });
    },

    updateProfileUser() {
      this.updateProfile().then((response) => {
        console.log(response)

        this.getUserProfile().then((response) => { 

          this.id = response.data.data.id
          this.username = response.data.data.name
          this.email = response.data.data.email
          this.phone = response.data.data.phone
          this.first_name = response.data.data.first_name
          this.last_name = response.data.data.last_name
          this.street_name = response.data.data.street_name
          this.house_number = response.data.data.house_number
          this.image = response.data.data.profile_pic
          if(this.image!==null) {
            this.imgUpload = true
          }

        });
         this.$toast.fire("Success :", "Profile details updated successfully", "success");
      });
    },

    deleteCurrentPhoto() {
      this.deletePhoto().then((resp)=>{ 
        console.log(resp)
        this.imgUpload = false
      })
    },

    onChange () {
      if (this.$refs.pictureInput.file) {
        this.image = this.$refs.pictureInput.file.name;
        console.log('Image', this.image);
      } else { 
        console.log('error')
      }
    },

  },
}
</script>

<style lang="scss" scoped>

.form-select {
  padding-left: 20px;
  font-size: 1rem;
  height: 50px;
  width: 100%;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 2px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.mobile {
  display: none;
  @media screen and (max-width: 768px) {
    display: block !important;
  }
}
.account {
  max-width: 1200px;
  margin: 105px auto 109px auto;
  position: relative;
  padding: 0 15px;
  &-wrapper {
    width: 100%;
    background-color: #ffffff;
  }
  &-btn {
    margin: 50px auto;
    width: 213px;
  }
  &_body {
    display: flex;
    flex-direction:row;
    align-items: center;
    justify-content: space-between;
    @media screen and (max-width: 768px) {
      flex-direction: column-reverse;
    }
    &_left {
      @media screen and (max-width: 768px) {
        width:100%;
        &_form {
          margin:0 74px 0 80px;
          @media screen and (max-width: 560px) {
            margin:0;
          }
          &-input {
            width:auto;
          }
        }
      }
    }
    &_right {
      display: flex;
      flex-direction: column;
      align-items: center;
      width:50%;
      @media screen and (max-width: 768px) {
        width: 100%;
      }
      &-button {
        width: 213px;
        height: 40px;
        background-color: #e40909;
        margin-top: 43px;
      }
      &_connect {
        width:76%;
        text-align: center;
        @media screen and (max-width: 900px) and (min-width: 768px){
          width:100%;
        }
        @media screen and (max-width: 768px) {
          display:none;
        }
        @media screen and (max-width: 560px) {
          width: 100%;
        }
        &-p {
          color: #9f9fa4;
          font-family: "Open Sans";
          font-size: 14px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0.35px;
        }
        &_networks {
          display: flex;
          flex-direction: row;
          justify-content:space-between;
          @media screen and (max-width: 380px) {
            flex-direction: column;
            align-items: center;
          }
          &_item {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width:28%;
            @media screen and (max-width: 900px) and (min-width: 768px){
              width: 32%;
            }
            @media screen and (max-width: 380px) {
              width: 50%;
            }
            p {
              font-family: "Open Sans";
              font-size: 14px;
              font-weight: 400;
              line-height: 24px;
              letter-spacing: 0.35px;
            }
            &-facebook {
              color: #3a559f;
            }
            &-twitter {
              color: #50abf1;
            }
            &-google {
              color: #dd4b39;
            }
          }
        }
      }
    }
  }
  &-subtitle {
    color: #adadad;
    font-family: "Open Sans";
    font-size: 12px;
    font-weight: 400;
    line-height: 36px;
    text-transform: uppercase;
    font-family: "Open Sans";
    font-weight: 400;
    letter-spacing: 0.3px;
    span {
      color: #fe0012;
      font-family: "Optimal C";
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 0.4px;
    }
  }
  &-h1 {
    color: #38383a;
    font-family: "Optimal C";
    font-size: 30px;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.07px;
  }
  &_border {
    width: 63px;
    height: 3px;
    background-color: #2a9854;
    margin-bottom: 46px;
  }
  &-date {
    color: #9f9fa4;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: 400;
    line-height: 36px;
    letter-spacing: 0.35px;
    margin:0;
    @media screen and (max-width: 768px) {
      margin: 0 74px 0 80px;
    }
    @media screen and (max-width: 560px) {
      margin: 0;
    }
    &_border {
      height: 1px;
      background-color: #dddddd;
      max-width: 293px;
      margin-bottom: 50px;
      @media screen and (max-width: 768px) {
        margin: 0 74px 50px 80px;
      }
      @media screen and (max-width: 560px) {
        margin: 0 0 50px 0;
      }
    }
  }
}
.input {
    position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 360px;
  margin-bottom: 19px;
    &-wrong {
      position: absolute;
      bottom:-38px;
      color: red;
      @media screen and (max-width: 480px) {
        bottom: -16px;
      }
    }
    &-redStar{
      color: #fe0012 !important;
      font-size: 24px !important;
      font-weight: bold !important;
      letter-spacing: 0.05px !important;
    }
    span {
      color: #38383a;
      font-family: "Optimal C";
      font-size: 18px;
      font-weight: 400;
      letter-spacing: 0.04px;
      margin-bottom: 15px;
    }
    input {
      outline: none;
      border: none;
      border-bottom: 1px solid #d1d1d1;
      color: #7a7a7d;
      font-family: "Open Sans";
      font-size: 16px;
      font-weight: 400;
      line-height: 45px;
      letter-spacing: 0.4px;
      background-color:transparent;
    }
}
</style>